import { EventModel } from '@frontend/sports/betting-offer/feature/model';

export function getLeagueId(event: EventModel): number {
    return event.league.parentLeagueId || event.league.id;
}
